import includes from 'lodash/includes'
import { createSelector } from 'reselect'
import { composeGetters } from 'react-redux-getters'
import { getMe } from 'selectors/me'
import { ADMIN, MANAGER } from 'constants/roles'
import { FREE, STARTER_MONTHLY, STARTER_ANNUAL } from 'constants/plans'

export const INTEGRATION_ADD_PERMISSION = 'integrationAdd'
export const INBOX_EXPORT_PERMISSION = 'inboxExport'
export const BUILD_EVENT_PERMISSION = 'buildEvent'
export const MANAGER_ADD_PERMISSION = 'managerAdd'

export const getPermissions = createSelector(
  getMe,
  meGetter => composeGetters(
    meGetter,
    (me) => {
      const { manager, plan } = me
      const { role } = manager || {}
      const adminRole = !role || role === ADMIN
      const managerRole = adminRole || role === MANAGER
      // console.warn('WTF it\'s called on each store update!!!')
      // console.log(me)
      return {
        buildTab: managerRole,
        customizeTab: adminRole,
        integrationsTab: managerRole,
        billingTab: adminRole,
        businessTab: adminRole,
        managersTab: adminRole,
        [INTEGRATION_ADD_PERMISSION]: plan !== FREE,
        [INBOX_EXPORT_PERMISSION]: plan !== FREE,
        [BUILD_EVENT_PERMISSION]: plan !== FREE,
        [MANAGER_ADD_PERMISSION]: !includes([FREE, STARTER_MONTHLY, STARTER_ANNUAL], plan),
      }
    }
  )
)
